<template >
    <TransitionRoot as="template" :show="show" >
        <Dialog as="div" class="relative z-10" @close="close" >
            <TransitionChild as="template" enter="ease-out duration-300" enter-from="opacity-0" enter-to="opacity-100"
                             leave="ease-in duration-200" leave-from="opacity-100" leave-to="opacity-0" >
                <div
                    class="hidden sm:fixed sm:inset-0 sm:block sm:bg-gray-500 sm:bg-opacity-75 sm:transition-opacity" />
            </TransitionChild >

            <div class="fixed inset-0 z-10 overflow-y-auto" >
                <div class="flex min-h-full items-stretch justify-center text-center sm:items-center sm:px-6 lg:px-8" >
                    <TransitionChild as="template" enter="ease-out duration-300" enter-from="opacity-0 scale-105"
                                     enter-to="opacity-100 scale-100" leave="ease-in duration-200"
                                     leave-from="opacity-100 scale-100" leave-to="opacity-0 scale-105" >
                        <DialogPanel class="flex w-full max-w-5xl transform text-left text-base transition sm:my-8" >
                            <div
                                class="relative flex w-full flex-col overflow-hidden bg-white pt-6 pb-8 sm:rounded-lg sm:pb-6 lg:py-8" >

                                <!-- Navigation arrows -->
                                <button v-if="navigable" @click="$emit('navigate-prev')"
                                        class="hidden sm:flex absolute left-0 top-1/2 -translate-y-1/2 z-20 items-center justify-center w-6 h-12 text-gray-300 hover:text-gray-500 transition-colors opacity-0 hover:opacity-100 focus:opacity-100">
                                    <ChevronLeftIcon class="h-4 w-4" />
                                </button>
                                <button v-if="navigable" @click="$emit('navigate-next')"
                                        class="hidden sm:flex absolute right-0 top-1/2 -translate-y-1/2 z-20 items-center justify-center w-6 h-12 text-gray-300 hover:text-gray-500 transition-colors opacity-0 hover:opacity-100 focus:opacity-100">
                                    <ChevronRightIcon class="h-4 w-4" />
                                </button>

                                <div >
                                    <div class="flex items-center justify-end px-4 sm:px-6 lg:px-8" >
                                        <button type="button" class="text-gray-400 hover:text-gray-500" @click="close" >
                                            <span class="sr-only" >Close</span >
                                            <XMarkIcon class="h-6 w-6" aria-hidden="true" />
                                        </button >
                                    </div >

                                    <div class="px-4 sm:px-6 lg:px-8 -mt-5" >
                                        <section class="min-h-[400px]" >
                                            <slot name="body" ></slot >
                                        </section >
                                    </div >
                                </div >

                                <slot name="footer" >

                                </slot >
                            </div >
                        </DialogPanel >
                    </TransitionChild >
                </div >
            </div >
        </Dialog >
    </TransitionRoot >
</template >

<script >
import {Dialog, DialogPanel, TransitionChild, TransitionRoot} from '@headlessui/vue'
import {XMarkIcon, ChevronLeftIcon, ChevronRightIcon} from '@heroicons/vue/24/outline'

export default {
    components: {
        Dialog, DialogPanel, TransitionRoot, TransitionChild, XMarkIcon, ChevronLeftIcon, ChevronRightIcon,
    },

    props: {
        show: {
            type: Boolean,
            default: false,
        },
        navigable: {
            type: Boolean,
            default: false,
        },
    },

    data() {
        return {};
    },

    methods: {
        close() {
            this.$emit('modal-close');
        },

        handleKeydown(e) {
            if (['INPUT', 'TEXTAREA', 'SELECT'].includes(e.target.tagName)) return;

            if (this.navigable) {
                if (e.key === 'ArrowUp') {
                    e.preventDefault();
                    this.$emit('navigate-prev');
                } else if (e.key === 'ArrowDown') {
                    e.preventDefault();
                    this.$emit('navigate-next');
                } else if (e.key === 'ArrowLeft') {
                    e.preventDefault();
                    this.$emit('tab-prev');
                } else if (e.key === 'ArrowRight') {
                    e.preventDefault();
                    this.$emit('tab-next');
                }
            }
        },
    },

    watch: {
        show(visible) {
            if (visible && this.navigable) {
                this._onKeydown = (e) => this.handleKeydown(e);
                window.addEventListener('keydown', this._onKeydown, true);
            } else if (this._onKeydown) {
                window.removeEventListener('keydown', this._onKeydown, true);
                this._onKeydown = null;
            }
        },
    },

    beforeUnmount() {
        if (this._onKeydown) {
            window.removeEventListener('keydown', this._onKeydown, true);
        }
    },

}
</script >
